<div class="height100p flex-col">
    <sm-toolbar class="mt-2 flex-item-fixed" [noBorder]=true>
        <button pButton icon="fas fa-plus" label="Dokument" (click)="addDocument()"></button>
    </sm-toolbar>
    <p-splitter class="height100p" panelStyleClass="flex-item-fill flex-row-split height100p overflow-y-auto">
    <ng-template pTemplate>
        <sm-table class="width100p" [data]="table" [floatingFilter]=true headerAlign="center" columnWidthMode="content" (onRowSelect)="rowSelect($event)" (onCellClicked)="clickCell($event)" (onRowDoubleClicked)="doubleClick($event)"></sm-table>
    </ng-template>
    <ng-template pTemplate>
        <app-pdf-viewer class="width100p height100p" [src]="pdfSrc"></app-pdf-viewer>
    </ng-template>
</p-splitter>
</div>
